import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
    AOS.refresh();
  }, []);

  const coreProducts = [
    {
      name: 'Control Panel',
      icon: 'bi bi-sliders2-vertical',
      desc: 'Custom-built panels for industrial control and automation.',
    },
    {
      name: 'Substation Equipment',
      icon: 'bi bi-building',
      desc: 'Reliable and robust solutions for power distribution.',
    },
    {
      name: 'Wiring Accessories',
      icon: 'bi bi-plug-fill',
      desc: 'High-quality wiring parts for safe installations.',
    },
    {
      name: 'Industrial Automation',
      icon: 'bi bi-cpu-fill',
      desc: 'Advanced systems to automate and optimize operations.',
    },
    {
      name: 'Renewable Energy',
      icon: 'bi bi-sun-fill',
      desc: 'Clean energy solutions for a sustainable future.',
    },
  ];

  return (
    <section id="about" className="about-us section py-5 mt-5">
      <div className="container" data-aos="fade-up">
        {/* New Company Intro Section */}
        <div className="mb-5 p-4 bg-white shadow rounded" data-aos="fade-up">
          <h3 className="text-primary mb-3">About Powerxone Engineering Limited</h3>
          <p className="text-muted">
            Powerxone Engineering Limited is a rising force in Bangladesh’s electrical power sector, committed to delivering
            high-quality and efficient energy infrastructure. We specialize in the supply, installation, and maintenance of
            electrical substations, Busbar Trunking Systems (BBT), and diesel generators for industrial, commercial, and real
            estate development projects.
          </p>
          <p className="text-muted">
            Founded by <b></b>, our company was born from a vision to bridge the gap between growing
            energy needs and reliable solutions. We combine global product quality with local expertise, ensuring each client
            receives power systems that are safe, durable, and customized to their unique requirements.
          </p>
          <p className="text-muted">
            With a strong team of certified engineers, electricians, and project managers, we provide turnkey solutions—from
            design consultation to commissioning and ongoing maintenance.
          </p>
        </div>

        {/* Existing Sections */}
        <div className="section-title text-center mt-5">
          <h3 className="text-muted">Who We Are & What We Stand For</h3>
        </div>

        <div className="row align-items-center gy-4">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="about-box p-4 shadow rounded bg-white h-100">
              <h3 className="text-primary mb-3">Our Vision</h3>
              <p className="mb-0 text-muted justify-text">
                To become one of Bangladesh’s most trusted providers of power distribution equipment and services by 2030—
                recognized for quality, safety, and service excellence.
              </p>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="about-box p-4 shadow rounded bg-white h-100">
              <h3 className="text-success mb-3">Our Mission</h3>
              <p className="mb-0 text-muted">
                To power Bangladesh’s growth with reliable, innovative, and cost-effective energy solutions that support
                sustainable infrastructure and industrial expansion.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-2 mt-5" data-aos="fade-up">
        <div className="aboutus-title text-center mb-0 ">
          <h3 className="text-dark">Our Core Products</h3>
          <p className="text-muted">Explore the innovative solutions we provide</p>
        </div>

        <div className="row g-4 justify-content-center">
          {coreProducts.map((product, index) => (
            <div
              key={index}
              className="col-6 col-sm-4 col-md-2-4"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <div className="core-card text-center p-3">
                <div className="core-icon mb-3">
                  <i className={product.icon}></i>
                </div>
                <h6 className="fw-bold">{product.name}</h6>
                <p className="text-muted small mb-0">{product.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
